
import { HOME_ROUTE } from '../app/shared/constants/constants';

export const environment = {
   name: 'develop',
  production: false,
  baseUrl: 'https://grens-mock-be.dotitsrl.it/api/v1',
  home: HOME_ROUTE,
  defaultLanguage: 'it',
  gtmId: 'GTM-XXXXXX'
};

